<template>
    <transition name="modal">
        <div class="dialog-modal-mask">
            <div class="small-panel" style="width: 750px" @click.stop>
                <div class="dialog-title-container">
                    <div v-if="!isModifyMode" class="dialog-title">{{ $t("message.title_buddy_bot_api_add_bot") }}</div>
                    <div v-else class="dialog-title">{{ $t("message.title_buddy_bot_api_edit_bot") }}</div>
                    <div class="dialog-button-group">
                        <el-button class="sample-dialog-button" @click="testConnection">{{ $t("message.item_buddy_bot_api_test_connect") }}</el-button>
                        <el-button class="sample-dialog-button" @click="showJsonDialog">{{ $t("message.item_buddy_bot_api_sample_payload") }}</el-button>
                    </div>
                </div>
                <hr class="dialog-hr">
                <div class="dialog-body-small">
                    <el-form label-width="200px">
                        <div class="dialog-form-item">
                            <el-form-item prep="displayName" ref="displayName">
                                <div slot="label" style="text-align:left">
                                    <span v-t="'message.item_display_name'"></span>
                                    <span class="required" v-t="'message.item_required'"></span>
                                </div>
                                <el-input id="displayName" size="large" type="text" :placeholder="$t('message.place_holder_input_text')" v-model="inputForm.displayName.value"
                                          @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                                          clearable @clear="inputCheckAll()"/>
                            </el-form-item>
                        </div>
                        <div class="dialog-form-item">
                            <el-form-item prep="objectName" ref="objectName">
                                <div slot="label" style="text-align:left">
                                    <span v-t="'message.item_buddy_bot_api_distinguished_name'"></span>
                                </div>
                                {{ $t(this.targetBotParam.objectName) }}
                            </el-form-item>
                        </div>
                        <div class="dialog-form-item">
                            <el-form-item label="endpoint" ref="endpoint">
                                <div slot="label" style="text-align:left">
                                    <span v-t="'message.item_target_url'"></span>
                                </div>
                                <el-input id="endpoint" size="large" type="text" :placeholder="$t('message.place_holder_input_text')" v-model="inputForm.endpoint.value"
                                          @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                                          clearable @clear="inputCheckAll()"/>
                            </el-form-item>
                        </div>
                        <div class="dialog-form-item">
                            <el-form-item label="ignoreWords" ref="ignoreWords">
                                <div slot="label" style="text-align:left"><span v-t="'message.item_ignore_words'"></span></div>
                                <el-input id="ignoreWords" size="large" type="text" :placeholder="$t('message.place_holder_input_text')" v-model="inputForm.ignoreWords.value"
                                          @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                                          clearable @clear="inputCheckAll()"/>
                            </el-form-item>
                        </div>
                        <div class="dialog-form-item">
                            <el-form-item label="authOption" ref="authOption">
                                <div slot="label" style="text-align:left">{{ $t("message.item_buddy_bot_api_auth_method") }}</div>
                                <el-select v-model="authOption" @change="onChangeAuthOption" class="dropdown-label">
                                    <el-option v-for="option in authOptions" :key="option.value" :label="option.displayName" :value="option.value"/>
                                </el-select>
                            </el-form-item>
                        </div>
                        <div class="dialog-form-item" v-show="authOption!=='none'">
                            <el-form-item label="authValue" ref="authValue">
                                <div slot="label" style="text-align:left">{{ $t("message.item_buddy_bot_api_auth_key_values") }}</div>
                                <el-input id="authValue" size="large" type="text" :placeholder="$t('message.place_holder_input_text')" v-model="inputForm.authValue.value"
                                          @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                                          clearable @clear="inputCheckAll()"/>
                            </el-form-item>
                        </div>
                        <span margin="10px">{{ $t("message.item_buddy_bot_api_custom_params") }}</span>
                        <el-tooltip effect="dark" placement="top-start">
                            <div slot="content" style="text-align:left" v-html="$t('message.hint_outbound_api_custom_params')"></div>
                            <img class="icon-help" :src="require('@/assets/icon_help.svg')" alt=""/>
                        </el-tooltip>
                        <div v-if="customParams.length > 0">
                            <el-row :gutter="20" style="align-items: center; margin-top: 10px;">
                                <el-col :span="10">
                                    <div style="text-align: left; margin-bottom: 5px;">
                                        <span>{{ $t("message.item_buddy_bot_api_auth_key") }}</span>
                                    </div>
                                </el-col>
                                <el-col :span="10">
                                    <div style="text-align: left; margin-bottom: 5px;">
                                        <span>{{ $t("message.item_buddy_bot_api_auth_value") }}</span>
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                        <div v-for="(form, index) in customParams" :key="index" class="dialog-form-item">
                            <el-row :gutter="20" style="align-items: center; margin-bottom: 5px;">
                                <el-col :span="10">
                                    <el-input
                                        v-model="form.key"
                                        placeholder="Json key"
                                        @compositionstart.native="compositionStartCustom(index)"
                                        @compositionend.native="compositionEndCustom(index)"
                                        @input.native="inputCheckCustomParam(index)"
                                    />
                                </el-col>

                                <el-col :span="10">
                                    <el-input
                                        v-model="form.value"
                                        placeholder="Json value"
                                        @compositionstart.native="compositionStartCustom(index)"
                                        @compositionend.native="compositionEndCustom(index)"
                                        @input.native="inputCheckCustomParam(index)"
                                    />
                                </el-col>

                                <el-col :span="4" style="text-align: right;">
                                    <el-button @click="removeParam(index)">{{ $t("message.common_action_delete") }}</el-button>
                                </el-col>
                            </el-row>

                            <div v-if="form.errorMessage" class="error-text">{{ form.errorMessage }}</div>
                        </div>
                        <br>
                        <el-button :disabled="this.customParams.length>=10" @click="addParam">{{ $t("message.item_buddy_bot_api_add_form") }}</el-button>
                    </el-form>
                </div>
                <hr class="dialog-hr">
                <div class="dialog-button-field">
                    <el-button class="dialog-cancel-button" @click="$emit('cancel')" v-t="'message.button_cancel'"></el-button>
                    <el-button class="dialog-ok-button" :disabled="this.$data.disableSaveButton" @click="save()" v-t="'message.button_save'"></el-button>
                </div>
                <DialogJsonSample v-if="isSampleDialogOpen" :targetBotParam="payload" @cancel="isSampleDialogOpen=false"></DialogJsonSample>
            </div>
        </div>
    </transition>
</template>

<script>
import server from "../../../ServerApi";
import commonValidate from '../../../common-validate.js';
import commonUtil from "../../../commonutil";
import constants from "../../../constants";
import BuddyBotPayloadSample from "./BuddyBotPayloadSample.vue";

export default {
    components: {DialogJsonSample: BuddyBotPayloadSample},
    props: ['targetBotInfo', 'targetBotParam'],
    data() {
        return {
            isSampleDialogOpen: false,

            labelWidth: "200px",

            authOption: "none",
            authOptions: [],

            isModifyMode: false,
            inputForm: {
                displayName: {validationRule: "reqDisplayName", valid: false, value: null, isComposing: false},
                endpoint: {validationRule: "url", valid: true, value: null, isComposing: false},
                ignoreWords: {validationRule: "text100", valid: true, value: null, isComposing: false},
                authValue: {validationRule: "reqToken", valid: true, value: null, isComposing: false},
            },

            disableSaveButton: true,
            customParamsJson: "",
            customParams: [],

            payload: null
        };
    },

    created() {
        this.authOptions = [
            {displayName: this.$t("message.item_buddy_bot_api_auth_method_none"), value: "none"},
            {displayName: this.$t("message.item_buddy_bot_api_auth_method_bearer"), value: "Bearer"},
            {displayName: this.$t("message.item_buddy_bot_api_auth_method_x_api_key"), value: "x-api-key"},
        ];
        if (this.targetBotInfo.id !== null) {
            this.isModifyMode = true;

            this.inputForm.displayName.valid = true;
            this.inputForm.endpoint.valid = true;
            this.inputForm.ignoreWords.valid = true;
            this.inputForm.authValue.valid = true;

            this.inputForm.displayName.value = this.targetBotParam.displayName;
            this.inputForm.endpoint.value = this.targetBotParam.endpoint;
            this.inputForm.ignoreWords.value = this.targetBotParam.ignoreWords;

            let result = this.convertAuthKeyValue(this.targetBotParam.authKey, this.targetBotParam.authValue);
            this.authOption = result.option;
            this.inputForm.authValue.value = result.value;

            if (this.targetBotParam.customParamsJson) {
                try {
                    const parsedParams = JSON.parse(this.targetBotParam.customParamsJson);
                    this.customParams = Object.keys(parsedParams).map(key => (
                        {key: key, value: parsedParams[key], validationRule: "reqKeyValue500", valid: true, errorMessage: "", isComposing: false}
                    ));
                } catch (error) {
                    console.error("Invalid JSON string in customParams", error);
                }
            }
        } else {
            let num;
            // Generate a totally random 8-character hex string for objectName
            if (window.crypto && window.crypto.getRandomValues) {
                const array = new Uint8Array(8);
                window.crypto.getRandomValues(array);
                num = Array.from(array)
                    .map(b => b.toString(16).padStart(2, '0'))
                    .join('');
            } else {
                // Fallback: generate 8 hex digits via Math.random
                let randomHex = '';
                for (let i = 0; i < 8; i++) {
                    randomHex += Math.floor(Math.random() * 16).toString(16);
                }
                num = randomHex;
            }

            this.targetBotParam.objectName = "BuddyBot" + num;
        }
    },

    methods: {
        testConnection() {
            let authKeyValue = this.createAuthKeyValue(this.authOption, this.inputForm.authValue.value);
            let customParamsJson = JSON.stringify(this.customParams.reduce((acc, param) => {
                if (param.key) acc[param.key] = param.value;
                return acc;
            }, {}));
            server.post("/buddybottestconnect", {
                displayName: this.inputForm.displayName.value,
                objectName: this.targetBotParam.objectName,
                endpoint: this.inputForm.endpoint.value,
                ignoreWords: this.inputForm.ignoreWords.value,
                authKey: authKeyValue.key,
                authValue: authKeyValue.value,
                customParamsJson: customParamsJson,
            }).then((response) => {
                if (response.status !== 200) {
                    commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_buddy_bot_api_internal_system"));
                } else {
                    switch (response.data.status) {
                        case constants.STATUS_SUCCESS:
                            commonUtil.notifyMessage(this, "Success");
                            break;
                        case constants.STATUS_ERROR_INVALID_PARAMETER:
                            commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_buddy_bot_api_invalid_params"));
                            break;
                        case constants.STATUS_ERROR_EXTERNAL_SYSTEM:
                            commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_buddy_bot_api_external_system"));
                            break;
                        case constants.STATUS_ERROR_EXCEEDS_MAX_COUNT:
                            commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_buddy_bot_api_exceeds_monthly_limit"));
                            break;
                        default:
                            commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_buddy_bot_api_internal_system"));
                            break;
                    }
                }
            }).catch(error => {
                commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_buddy_bot_api_internal_system"));
            });
        },
        inputCheck(eventTargetId) {
            if (this.inputForm[eventTargetId].isComposing) {
                return;
            }
            if (eventTargetId === "authValue" && this.authOption === "none") {
                this.inputForm[eventTargetId].valid = true;
                this.setButtonStatus();
                return;
            }
            const validateResult = commonValidate.validateItem(
                this.$i18n,
                this.inputForm[eventTargetId].validationRule,
                this.inputForm[eventTargetId].value
            );
            if (!validateResult.valid) {
                this.$refs[eventTargetId].validateState = "error";
                this.$refs[eventTargetId].validateMessage = validateResult.message;
            } else {
                this.$refs[eventTargetId].validateState = "success";
                this.$refs[eventTargetId].validateMessage = "";
            }

            this.inputForm[eventTargetId].valid = validateResult.valid;
            this.setButtonStatus();
        },
        inputCheckCustomParam(index) {
            if (this.customParams[index].isComposing) return;

            const validateResult = commonValidate.validateItem(
                this.$i18n,
                this.customParams[index].validationRule,
                this.customParams[index].key,
                this.customParams[index].value
            );
            const keys = this.customParams.map(param => param.key);
            const isDuplicate = keys.indexOf(this.customParams[index].key) !== keys.lastIndexOf(this.customParams[index].key);

            if (!validateResult.valid) {
                this.customParams[index].errorMessage = validateResult.message;
            } else if (isDuplicate) {
                this.customParams[index].errorMessage = this.$t("message.error_buddy_bot_api_duplicate_key");
                this.customParams[index].valid = false;
            } else {
                this.customParams[index].errorMessage = "";
            }

            this.customParams[index].valid = validateResult.valid && !isDuplicate;
            this.setButtonStatus();
        },
        inputCheckAll() {
            Object.keys(this.inputForm).forEach(targetId => this.inputCheck(targetId));
            this.customParams.forEach((param, index) => this.inputCheckCustomParam(index));
        },
        onChangeAuthOption() {
            this.inputForm.authValue.value = "";
            this.inputCheck("authValue");
        },
        setButtonStatus() {
            const isFormValid = commonValidate.checkFormValidation(this.inputForm);
            const areCustomParamsValid = this.customParams.every(param => param.valid);
            this.disableSaveButton = !(isFormValid && areCustomParamsValid);
        },
        addParam() {
            this.customParams.push({key: "", value: "", validationRule: "reqKeyValue500", valid: false, errorMessage: "", isComposing: false});
        },
        removeParam(index) {
            this.customParams.splice(index, 1);
            this.setButtonStatus();
        },
        save() {
            const payload = this.createPayload();

            this.$emit(this.isModifyMode ? 'modify' : 'add', payload);
        },
        compositionStart(eventTargetId) {
            this.inputForm[eventTargetId].isComposing = true;
        },
        compositionEnd(eventTargetId) {
            this.inputForm[eventTargetId].isComposing = false;
            this.inputCheck(eventTargetId);
        },
        compositionStartCustom(index) {
            this.customParams[index].isComposing = true;
        },
        compositionEndCustom(index) {
            this.customParams[index].isComposing = false;
            this.inputCheckCustomParam(index);
        },
        showJsonDialog() {
            this.payload = this.createPayload();
            this.isSampleDialogOpen = true;
        },
        createCustomParamsJson() {
            return JSON.stringify(this.customParams.reduce((acc, param) => {
                if (param.key) acc[param.key] = param.value;
                return acc;
            }, {}));
        },
        createPayload() {
            let authHeader = this.createAuthKeyValue(this.authOption, this.inputForm.authValue.value);
            const customParamsJson = this.createCustomParamsJson();

            return {
                displayName: this.inputForm.displayName.value,
                objectName: this.targetBotParam.objectName,
                endpoint: this.inputForm.endpoint.value,
                ignoreWords: this.inputForm.ignoreWords.value,
                authKey: authHeader.key,
                authValue: authHeader.value,
                customParamsJson: customParamsJson,
            };
        },
        createAuthKeyValue(option, value) {
            switch (option) {
                case "Bearer":
                    return {key: "Authorization", value: "Bearer " + value};
                case "x-api-key":
                    return {key: "x-api-key", value: value};
                default:
                    return {key: null, value: null};
            }
        },
        convertAuthKeyValue(authKey, authValue) {
            if (authKey === "Authorization") {
                return {option: "Bearer", value: authValue.replace("Bearer ", "")};
            } else if (authKey === "x-api-key") {
                return {option: "x-api-key", value: authValue};
            } else {
                return {option: "none", value: null};
            }
        },
    }
};
</script>

<style scoped>
.error-text {
    color: #f56c6c;
    font-size: 12px;
    line-height: 1.5;
    margin-left: 10px;
}

.dialog-title-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.dialog-title {
    display: flex;
    align-items: center;
    height: 100%;
    text-align: left;
}

.dialog-button-group {
    margin-left: auto;
    display: flex;
    gap: 10px;
}

.sample-dialog-button {
    margin: 10px;
}

.dropdown-label {
    width: 150px;
}
</style>
